import { FunctionComponent } from 'react';

export interface UpdateProductTabProps {
  productID: number;
}

export enum UpdateProductTabKind {
  DETAILS = 'DETAILS',
  MEDIA = 'MEDIA',
  OPTIONS = 'OPTIONS',
  SEO = 'SEO',
  RELATED_PRODUCTS = 'RELATED_PRODUCTS',
}

export interface UpdateProductTabDef {
  kind: UpdateProductTabKind;
  name: string;
  path: string;
  element: FunctionComponent<UpdateProductTabProps>;
}
